export enum OrderEnum {
    ASC = 'ASC',
    DESC = 'DESC',
}

export interface Pagination<T> {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    items: T[];
    page: number;
    take: number;
    totalItems: number;
    totalPages: number;
}

export const defaultPaginationParameters: Readonly<PaginationParameters> = {
    order: OrderEnum.DESC,
    page: 0,
    take: 10,
};

export const defaultPageSizeOptions: Readonly<number[]> = [10, 20, 50];

export const paginationMaxTake = 50;

export interface PaginationParameters {
    isCaseSensitive?: boolean;
    order: OrderEnum;
    orderBy?: string;
    page: number;
    take: number;
    totalItems?: number;
}
